var v = cookie_get('playing.volume');
if (v != null && v == 0) v = 0.01;
var s = cookie_get('playing.shuffle');

var Static = {
	playing: {volume: (v != null ? v : 0.8)},
	user: {}
};

var MultiSocket = function(url, send_on_open) {
	var ms = this;

	ms.url = url;

	ms.listeners = {};
	ms.senders = [send_on_open];
	ms.opened = false;
	ms.debug = false;
	ms.send_on_open = send_on_open;

	ms.connect = function() {
		try {
			ms.sock = new WebSocket(ms.url);
		} catch(err) {
			console.error(err);
			return false;
		}
		if(ms.sock.readyState == 3)
			$(".user-bar-align").append("<div class='links right visible-desktop'><a href='/help/adblock' title='adBlock'>&nbsp;<img class='button' src='/resource/image/icon/cry2.png' width='64px'></a></div>");

		ms.sock.onopen = function() {
			if(Static.user.id == 1621) ms.debug = true;
			if(ms.senders.length) for(var i = 0; i < ms.senders.length; i++) ms.sock.send(JSON.stringify(ms.senders[i]));
			ms.opened = true;
			if(ms.debug) console.log('open');
			ms.ping();
			$('.websockets').hide();
		};

		ms.ping = function() {
			if(!ms.sock || ms.sock.readyState !== 1) return;
			ms.sock.send(0xA);
			setTimeout(ms.ping, 300000);
		};

		ms.sock.onmessage = function(e) {
			if(ms.debug) console.log(e);
			try {
				e = JSON.parse(e.data);
				var act = e[0]; e = e[1];
			} catch(error) { return; }

			if(ms.debug) console.log('action: ', act, e);
			if(typeof ms.listeners[act] == 'function') ms.listeners[act](e);
		};

		ms.send = function(params) {
			params = JSON.stringify(params);
			if(ms.opened == true) ms.sock.send(params);
			else {
				var send_timeout = setInterval(function() {
					if(ms.opened == true) {
						clearInterval(send_timeout);
						ms.sock.send(params);
					}
				}, 200);
			}
			if(ms.debug) console.log('sent: ' + params);
		};

		ms.sock.onclose = function(e) {
			ms.opened = false;
			if(ms.debug) console.log('close: ' + e.code + "; reason: " + e.reason);
			if(e.code != 3000 && e.code != 1000) setTimeout(ms.connect, Math.floor(Math.random()*50000) + 10000);
		};

		ms.sock.onerror = function(e) {
			console.error(e);
			showGlobalError('Не удалось соединиться с websocket сервером. Вероятно соединение заблокировано каким-нибудь расширением браузера. У вас не будут работать комментарии, личные сообщения и просмотры.');
		};

		ms.bind = function(action, params, handler, callback) {
			if(typeof params == 'function') {
				ms.listeners[action] = params;
				if(ms.debug) console.log('subscribing (no sending): ' + action);
				return true;
			}

			ms.listeners[action] = handler;
			ms.senders.push(params);

			if(typeof callback == 'function') callback();

			ms.send(params);
			if(ms.debug) console.log('subscribing: ' + action);
		};

		ms.unbind = function(action) {
			clearTimeout(ms.listeners[action]);
			delete ms.listeners[action];
		}
	}; // connect

	ms.connect();
};

function showGlobalError(text) {
	var el = $('.global-error');
	if (el.length) {
		el.find('div').html(text);
		el.show().addClass('websockets');
	}
}

function video_Watched() {
	$('.object-rating img').removeClass('inactive');
	$('#count-view').inc(true);
	$('#count-view-today').inc(true);
}

function lightbox_init() {
	if (Static.lightbox) {Static.lightbox.clear($('a.highslide')); return;}
	if (!$('a.highslide').length) return;

	var activityIndicatorOn = function() {$("<div class='loading'><div></div></div>").appendTo('body');},
		activityIndicatorOff = function() {$('.loading').remove();},
		overlayOn = function() {$('<div id="imagelightbox-overlay"></div>').appendTo('body');},
		overlayOff = function() {$('#imagelightbox-overlay').remove();},

	switchImage = function(target, direction) {
		var selector = $('a.highslide'),
			index = selector.index(target), new_target;
		if (direction == -1) {
			for (index--; index >= 0; index--) {
				new_target = $(selector).eq(index);
				if (new_target.parents('.carusel').length) break;
			}
		} else {
			for (index++; index <= $(selector).length; index++) {
				new_target = $(selector).eq(index);
				if (new_target.parents('.carusel').length) break;
				if (index == $(selector).length) index = -1;
			}
		}

		Static.lightbox.switchImageLightbox(index);
	},

	arrowsOn = function(target) {
		var $arrows = $('<button type="button" class="imagelightbox-arrow imagelightbox-arrow-left"></button><button type="button" class="imagelightbox-arrow imagelightbox-arrow-right"></button>');

		$arrows.appendTo('body')
		.on('click touchend', function(e) {
			e.preventDefault();

			if($(this).hasClass('imagelightbox-arrow-left')) {
				switchImage(target, -1);
			} else {
				switchImage(target, 1);
			}

			return false;
		});

		$(document).one('page.clean', function() {$arrows.remove();});

		/*$('body').on('flick', '#imagelightbox', function(e) {console.log(target);
			if ('horizontal' == e.orientation) {
				switchImage(target, e.direction);
			}
			return false;
		});*/
	},
	arrowsOff = function() {$('.imagelightbox-arrow').remove();};

	Static.lightbox = $('a.highslide').imageLightbox({
		animationSpeed: 50,
		quitOnImgClick: true,
		onStart: function() {overlayOn();},
		onEnd: function() {overlayOff(); arrowsOff(); activityIndicatorOff();},
		onLoadStart: function(target) {activityIndicatorOn(); if(target.parents('.carusel').length) arrowsOn(target); else arrowsOff();},
		onLoadEnd: function(target) {activityIndicatorOff(); if(target.parents('.carusel').length) $('.imagelightbox-arrow').css('display', 'block');}
	});
}

//--------------------------------------------------------------------------------------------------

function get_Position(v_id, duration, position) {
	var pos = localStorage.getItem('pos' + v_id);
	if (pos) {
		if (duration > 150 && pos > duration - 30) pos = 0;
		else if (duration <= 150 && pos > duration - 15) pos = 0;

		return pos;
	} else return position;
}

function video_Init(video, ad, position) {
	video = JSON.parse(window.atob(video));
	var flash_force = false;//cookie_get('no_html5') == 1;
	for (var key in video) {$('#video-flash').attr(key, video[key]);}

	var url = video.url;
	var v_id = video.v_id;
	if (ad && ad.vast && !ad.force && !ad.debug && cookie_get('ad_disable')) ad.vast = false;

	$('#video-flash').mediaelementplayer({
		type: video.type ? video.type : 'video/mp4',
		poster: video.image,
		videoWidth: $('#video-flash').width(),
		videoHeight: $('#video-flash').height(),
		mode: !flash_force ? 'auto' : 'auto_plugin',
		duration: video.duration,
		//alwaysShowHours: video.duration > 3600,
		vastAdTagUrl: ad && ad.vast ? ad.vast : "",
		vastFallback: ad && ad.vast_fallback && ad.vast_fallback ? ad.vast_fallback : "",
		features: ['playpause','current','progress','duration','speed','zoom','tracks','soundtracks','videotracks','volume','fullscreen','vast','contextmenu'],
		tracks: video.tracks,
		audio_tracks: video.audio_info,
		bufferingGoal: typeof Static.user != 'undefined' && Static.user.vip ? 50 : 30,
		debug: typeof Static.user != 'undefined' && Static.user.id == 1621,
		parent: video,
		success: function(media, node) {
			var player = node.player, events = [];
			Static.player = player;

			if (video.api && typeof parent == 'undefined') video.api = false;
			if (video.api) {parent.postMessage("init", "*"); parent.postMessage({'event': 'inited'}, "*");}

			var fix_wrong_audio = false;
			var ua = window.navigator.userAgent;
			if (video.audio > 1 && !video.dash) {
				fix_wrong_audio = ua.match(/opera|opr|firefox|YaBrowser|Edge|rv:|Vivaldi|msie|mms/i) !== null && ua.match(/windows nt (6.|10.)/i) !== null;
			}

			var hash = document.location.hash.substring(1);

			if (/(\d+):(\d+)/i.test(hash)) {position = video_Seek(hash, 1); video.play = true;}
			else if (!video.play) {
				position = get_Position(video.v_id, video.duration, position);
				if (position == -1) position = 0;
			}

			player.setSrc(!fix_wrong_audio || video.dash ? url : url + "?stream=1", !fix_wrong_audio || !video.url2 ? video.url2 : video.url2 + "?stream=1", video.track);
			if (video.dash && position >= 0) player.setCurrentTime(position);
			if (!flash_force && player.media.pluginType != 'native') cookie_set('no_html5', 1);

			if (video.play) player.load();
			if (!$('.overlay_video').length && ad && ad.overlay) video_ad_overlay();
			var setPos = function() {
				if (video.play) {player.play(); video.play = false;}
				if (position && position >= 0 && !video.dash) {
					player.setCurrentTime(position);
					position = 0;
				}
				media.removeEventListener('loadedmetadata', setPos, false);
			};
			media.addEventListener('loadedmetadata', setPos, false);
			if (ad && ad.vast) cookie_set('ad_disable', 'vast', 60);

			if (!Static.sock) {
				var guest = cookie_get('guest');
				if (guest) var guest_id = guest.split('|', 1)[0];
				if (guest_id) {
					Static.sock = new MultiSocket(window.location.protocol != 'https:' ? 'ws://s.krasview.ru:8091' : 'wss://s.krasview.ru', { action: 'subscribe', guest_id: guest_id });
					Static.sock.bind('video_Watched', video_Watched);
				}
			}

			var mark_end = 0;
			/*if (video.marks.length) {
				for (var i in video.marks) {if (video.marks[i].s == 'e') mark_end = video.marks[i].t;}
			}*/

			var lastTime = 0, progress_int = video.duration > 10 ? 10 : 1, countDebug = 0;
			if (!Static.sock) var progress = 0, lastTimestamp = Date.now() / 1000, watched = 0;
			media.addEventListener('timeupdate', function() {
				var ct = parseInt(media.currentTime);
				if (mark_end && ct >= mark_end && ct < mark_end + 2) {
					media.stop();
					if (!getNext(0, 1)) on_video_end();
				}
				if (video.api && events.indexOf('onTimeUpdate') != -1 && ct != lastTime) {
					parent.postMessage({'event': 'timeupdate', 'time': ct, 'duration': video.duration}, "*");
				}
				if (media.dash_player && ct != lastTime) {
					var stat = media.dash_player.getStats();
					//if (t.options.debug) console.log(stat);
					if (stat.estimatedBandwidth < stat.streamBandwidth * 0.7) {
						if (countDebug == 10) {
							if (Static.sock) Static.sock.send({
								action: 'lag',
								video_id: video.v_id,
								url: player.src,
								user_agent: ua,
								streamBandwidth: parseInt(stat.streamBandwidth),
								estimatedBandwidth: parseInt(stat.estimatedBandwidth),
							});
						}
						countDebug++;
					}
				}
				if (ct != lastTime && ct % progress_int === 0 && ct > 1) {
					if (ct > video.duration - 60) video_line_show(true);
					if (Static.sock) Static.sock.send({action: 'video_upd_pos', video_id: video.v_id, time: ct});
					else if (!watched) {
						var curTimestamp = Date.now() / 1000;
						if (ct > lastTime && ct - lastTime <= curTimestamp - lastTimestamp + 1) progress += ct - lastTime;
						if (progress > video.duration * 0.3) {
							watched = 1;
							$.get(video.href + '?watched=' + btoa(video.v_id + "m4Wa9rGCSeu4T95G"));
						}
						lastTimestamp = curTimestamp;
					}
					lastTime = ct;
					localStorage.setItem('pos' + video.v_id, ct);
				}
			}, false);

			media.addEventListener('volumechange', function(e) {
				if (video.api && events.indexOf('onVolumeChange') != -1 && !isNaN(media.volume)) { parent.postMessage({ 'event': 'volumechange', 'volume': media.volume, 'muted': media.muted }, "*"); }
				if (!isNaN(media.volume) && media.volume != Static.playing.volume) audio_playerVolume(media.volume);
			}, false);

			var to_next = function(data) {
				/*if(data.error && video.channel && video.mode == 'series') {
					$.get("/series/" + video.channel + "/?section=serie_next.xml", {'idx': video.i}, to_next, 'json');
					return;
				}*/
				if (data.error && player.isFullScreen) { player.exitFullScreen(); on_video_end(); }
				if (data.href && !player.isFullScreen) redirect(data.href + '?play' + (player.audioTrack ? "&track=" + player.audioTrack : ""));
				else if (data.url) {
					//if(media.dash_player && !data.dash) {media.dash_player.destroy().then(function() {media.dash_player = 0; reload(data);}); return;}
					//if(media.dash_player) {media.dash_player.unload().then(function() {reload(data);}); return;}
					/*if(!media.dash_player && data.dash) {
						media.dash_player = mejs.DashApi.init(media);
						reload(data);
					} else*/ reload(data);
				} else on_video_end();
			}, reload = function(data) {
				data.forward = video.forward;
				video = data;
				for (var key in video) $('#video-flash').attr(key, video[key]);
				var newSrc = player.setSrc(fix_wrong_audio && video.audio > 1 && !video.dash ? video.url + "?stream=1" : video.url, fix_wrong_audio && video.audio > 1 && video.url2 ? video.url2 + "?stream=1" : video.url2, player.audioTrack);
				newSrc.then(function() {
					player.setCurrentTime(0);
					player.play();
					if (!Static.sock) {progress = 0; lastTimestamp = Date.now() / 1000; watched = 0;}
					player.setPoster(video.image);
					player.setTracks(video.tracks);
					player.reinitControls();
				}, function(err) {alert(err);});
			}, on_video_end = function() {
				if (ad && ad.postroll && !player.options.vastPostroll) {
					player.options.vastPostroll = true;
					player.options.vastAdTagUrl = ad.postroll;
					if (ad.postroll_fallback) player.options.vastFallback = ad.postroll_fallback;
					player.buildvast(player, null, player.layers, null);
				}
			};

			var getNext = function(direction, auto) {
				if (video.next) {$.get("/ajax/video_next", {'video_id': video.v_id, 'direction': direction, 'auto': auto}, to_next, 'json'); return true;}
				else if (video.channel && ((auto && video.forward == 1) || !auto)) {
					$.get("/ajax/serie_next", {'idx': video.i, 'channel': video.channel, 'direction': direction, 'auto': auto}, to_next, 'json');
					return true;
				}
				return false;
			}
			media.addEventListener('ended', function() {
				if (video.api) {
					parent.postMessage({'event': 'ended', 'time': parseInt(media.currentTime)}, "*");
					on_video_end();
					return;
				}
				if (!getNext(0, 1)) on_video_end();
			}, false);

			media.addEventListener('pause', function() {
				if (video.api) parent.postMessage({'event': 'paused', 'time': parseInt(media.currentTime)}, "*");
				video_line_show(true);
			}, false);
			media.addEventListener('playing', function() {
				if (video.api) parent.postMessage({'event': 'started', 'time': parseInt(media.currentTime)}, "*");
				video_line_show(false);
			}, false);

			var vip = false;
			if (typeof video.need_vip != 'undefined' && cookie_get('vip-ad') == null) {
				media.addEventListener('playing', function() {
					if (!vip) video_vip_ad();
					vip = true;
				}, false);
			}

			if (!player.container) return;

			if (video.api) {
				window.addEventListener('message', function(e) {
					switch(e.data[0]) {
						case 'play': player.play(); break;
						case 'pause': player.pause(); break;
						case 'stop': if(!media.paused) player.pause(); break;
						case 'setVolume': /*player.setVolume(e.data[1] / 100);*/ media.volume = e.data[1] / 100; break;
						case 'seek': player.setCurrentTime(e.data[1]); break;
						case 'mute': player.setMuted(true); break;
						case 'unmute': player.setMuted(false); break;
						case 'subscribe': events.push(e.data[1]); break;
						case 'tv': player.options.noControls = true; player.hideControls(false); break;
					}
				}, false);
			}

			player.container.on('controlshidden', function() {
				if (player.isFullScreen) $("body").css('cursor', 'none');
				else if ($("body").css('cursor') == 'none') $("body").css('cursor', '');
			});

			player.container.on('controlsshown', function() {
				if ($("body").css('cursor') == 'none') $("body").css('cursor', '');
			});

			player.container.on('video.next', function() {getNext(0, 0);});
			player.container.on('video.prev', function() {getNext(1, 0);});
			player.container.on('mejsprerollended', function() {
				cookie_set('ad_disable', 'vast', 120);
			});

			player.globalBind(mejs.MediaFeatures.fullScreenEventName, function() {
				if (!player.isFullScreen) {
					if (typeof screen.orientation != 'undefined') screen.orientation.unlock();
					if ($("body").css('cursor') == 'none') $("body").css('cursor', '');
					if (video.v_id != v_id && typeof video.href != 'undefined') redirect(video.href);
				} else {
					if (!player.controlsAreVisible) $("body").css('cursor', 'none');
					if (typeof screen.orientation != 'undefined') screen.orientation.lock('landscape').catch(function e() {});
				}
			});

			function on_wheel(e) {
				var delta = e.originalEvent.deltaY || e.originalEvent.detail || e.originalEvent.wheelDelta;
				var newVolume = Math.min(media.getVolume() + (delta > 0 ? -0.1 : 0.1), 1);
				if (newVolume >= 0 && newVolume <= 1) media.setVolume(newVolume);
				e.preventDefault();
			}

			player.container.on('wheel', function(e) {
				if (player.isFullScreen) on_wheel(e);
			});

			$(".mejs-controls").on('wheel', function(e) {
				if (!media.paused) on_wheel(e);
			});

			if (typeof (on_play) == "function") {
				if (!document[fn.fullscreenEnabled]) $('.mejs-fullscreen-button').on('click', on_play);
			}

			if (ad && ad.pause) video_ad_pause();
		}
	});
	//if(!Static.mobile) video_pip_on_scroll();
}

function video_vip_ad() {
	$("#static-content").dialog({
		title: "Реклама VIP",
		text: '<div id="loading" style="display:block;"></div>',
		width: 900
	});
	$.get("/ajax/vip-form", function(data) {$("#dialog-content-top").html(data); cookie_set('vip-ad', 1, 3600 * 12);});
	return false;
}

function video_line_show(show) {
	var line = $('.mejs-layers #video-line-container');
	if (line.length && !show) line.hide();
	if (line.length && show) line.show();
}

function video_line_init(pos) {
	$('<div id="video-line-container" class="mejs-overlay mejs-layer"><a class="buttons next" href="#">&#62;</a><a class="buttons prev" href="#">&#60;</a></div>').appendTo(".mejs-layers");
	$("#video-line").appendTo("#video-line-container")
	.on("wheel", function(e) {
		$(this).trigger(e.originalEvent.wheelDelta < 0 ? "next" : "prev");
		return false;
	})
	.serialScroll({
		"items": "#video-line-content a",
		"prev": ".prev", "next": ".next",
		"step": 5, "start": pos, "force": true,
		"onJump": function(curpos, limit) {
			if (curpos == limit) $('.next').hide();
			else $('.next').show();
			if (curpos == 0) $('.prev').hide();
			else $('.prev').show();
		}
	});
}

function video_pip_on_scroll() {
	var container = document.querySelector('#html5-container'), offset = offsetPosition(container), $container = $(container), pip = false, width = 300;
	window.onscroll = throttle(function() {
		if (window.scrollY < offset + 200) {
			if (pip) {
				pip = false;
				$('#mep_0').appendTo('#html5-container');
				$('.pip').remove();
			}
		} else if(!pip) {
			pip = true;
			var height = width * $container.data('ratio');
			$("<div class='pip' style='height: " + height + "px'></div>").appendTo('body');
			$('#mep_0').appendTo('.pip');
			$('.pip').css({right: '20px'});
			Static.player.setPlayerSize();
		}
	});
}

function video_ad_overlay() {
	setTimeout(function() {
		if ($("#overlay").length && $("#overlay").html().length < 100) video_ad_pause_disable();
	}, 2000);
	var html = "<div class='overlay_video'><div class='overlay'></div>";
	$(".mejs-layers").append(html);
	$("#overlay").appendTo(".overlay").show();
	$("<div class='close-overlay'></div>").appendTo("#overlay");
	$(".overlay_video .close-overlay").on("click", function(event) {event.stopPropagation(); video_ad_pause_disable();});
	setTimeout(video_ad_pause_disable, 10000);
}

function video_ad_pause_disable() {
	$(".overlay_video").html("");
}

function video_Seek(t, ret) {
	if (!Static.player) {
		getFlash('video-flash').seek(t, true);
	} else {
		var time = t.split(":");
		if (time.length < 2) return 0;
		var position = parseInt(time[0], 10) * 60 + parseInt(time[1], 10);
		if (time.length == 3) position = position * 60 + parseInt(time[2], 10);
		if (typeof ret != 'undefined') return position;

		Static.player.setCurrentTime(position);
		if (Static.player.paused !== false) {
			var onLoad = Static.player.load();
			onLoad.then(function() {Static.player.setCurrentTime(position);})
		}
		if ($.scrollTo) {
			$.scrollTo($('#video-container'), {duration: 0, offset: {left: 0, top: -100}});
			Static.player.play();
		}
	}
	return 0;
}

function offsetPosition(e) { // отступ от верхнего края экрана до элемента
	var offsetTop = 0;
	do {offsetTop += e.offsetTop;} while(e = e.offsetParent);
	return offsetTop;
}

function on_scroll_init(id) {
	var sidebar = document.querySelector('#' + id), doc_height = $("#content-table").height(),
		top = $('#' + id).css('padding-top'), offset = 0;

	window.onscroll = function() {
		if (window.pageYOffset < doc_height - $('#content-sidebar').height()) {
			var sidebar_offset = offsetPosition(sidebar);
			if (window.pageYOffset > sidebar_offset - 45) offset = window.pageYOffset - sidebar_offset + 45; else offset = 0;
			if (top != offset) $('#' + id).css('padding-top', offset);
		}
	}
}

function audio_playerVolume(val) { //0-1
	if (isNaN(val)) return;
	cookie_set('playing.volume', val);
	Static.playing.volume = val;
	if (Static.playing.mode == 'flash' && getFlash('audio-flash')) getFlash('audio-flash').callVolume(val); else if(Static.playing.mode == 'html5') Static.audio.volume = val;
}

function page_video() {
	function on_time_click() {
		var t = $(this).attr('href').split('#');
		video_Seek(t[1]);
		return false;
	}

	$(document).on('click', 'a.seek', on_time_click);

	function video_line_scroll(delta) {
		$('#video-line').scrollTo({left: (delta > 0 ? '-=' : '+=') + Math.abs(Math.ceil(delta)) + 'px', top: 0}, 0);
	}

	$('#video-line').on('wheel', function(e) {
		video_line_scroll(e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -e.originalEvent.deltaY * 40)
		return false;
	});
	var touchstart = 0;
	$('#video-line').on('touchstart', function(e) {touchstart = e.originalEvent.touches[0].pageX;}).on('touchmove', function(e) {
		video_line_scroll(e.originalEvent.touches[0].pageX - touchstart);
		touchstart = e.originalEvent.touches[0].pageX;
	});
}

function page_init() {
	if (Static.mobile && $('.resp').length) nbl.l("/resource/js/stacktable.min.js", function() {$('.stackcolumns').stackcolumns(); $('.card').cardtable(); $('.stack').stacktable();});
	$("#main-menu").click(function(e) {if (e.target === this) redirect("/");});
	player_ratio();

	$('#nav-dropdown').hover(function() {
		var nav = $('#nav');

		$('ul:first', this).css({top: nav.height() - 15}).show();
		$(this).find('a:first').addClass('s');
	}, function() {
		$('ul:first', this).hide();
		$(this).find('a:first').removeClass('s');
	});

	$("#news .post a .heading").shave(30);
	$(".channel-gallery-small .title").shave(30);

	$('.delete').click(function(e) {
		return confirm('Удаление: вы уверены?');
	});

	nbl.l("/resource/js/imagelightbox.min.js", lightbox_init);
}

function site_init(site) {
	if (typeof window.matchMedia == 'function') {
		var mql = window.matchMedia("(max-width: 767px)");
		Static.mobile = mql.matches;
	} else Static.mobile = false;
	if (!Static.mobile) $('#viewport').attr('content', 'width=device-width, initial-scale=1.0');

	if (site == true) return;

	Static.headsUp = new headsUp('#user-bar', {delay: Static.mobile ? 100 : 300});

	if (!Static.mobile || !('ontouchstart' in window)) {
		$('.links-dropdown').on({
			'mouseenter': function() {$(this).addClass('dropdown-active');},
			'mouseleave': function(e) {/*console.log(e.originalEvent.buttons); if (e.relatedTarget || e.toElement)*/ if (e.originalEvent.buttons == 0) $(this).removeClass('dropdown-active');}
		});
	} else {
		$('.links-dropdown > a').on('touchstart', function(e) {
			var cur = $(e.target).parent(), is_active = false;

			if (cur.hasClass("avatar-link")) cur = cur.parent().parent();
			if (cur.hasClass("user-bar-align")) cur = $(e.target);

			var is_parent = cur.hasClass('links-dropdown');
			$(".dropdown-active").each(function() {if (cur[0] == this) is_active = true; var cur_act = $(this); setTimeout(function() {cur_act.removeClass('dropdown-active');}, is_parent ? 0 : 300);});

			if (is_parent && !is_active) {
				cur.addClass('dropdown-active').find('.dropdown').show();
				e.preventDefault();
			}
			return true;
		});
		// https://css-tricks.com/dangers-stopping-event-propagation/
		$(document).on('click', function(event) {
			if (!$(event.target).closest('#user-bar-align').length) {
				$(".dropdown-active").removeClass('dropdown-active');
			}
		});
		/*$(window).click(function(e) {
			$(".dropdown-active").removeClass('dropdown-active');
		});*/
	}

	/*var ab = cookie_get('ab.scrollUp');
	if(!ab) {
		var right = Math.random() >= 0.5;
		ab = right ? 'right' : 'left';
		cookie_set('ab.scrollUp', ab, 86400 * 7);
	}
	if(ab == "right") {
		$('#scrollup').css({'padding': '100% 10px 6px 10px', 'right': '0px', 'left': 'unset', 'height': 'unset', 'top': 'unset'});
	}*/

	var up = $("#scrollup");
	if (up.length) {
		up.click(function() {
			//if(yaCounter) yaCounter.params({ab_test: ab});
			window.scroll(0,0);
			return;
		});
		window.addEventListener('scroll', throttle(function() {
			if($(window).scrollTop() > 300) up.show();
			else up.hide();
		}, 100), false);
	}

	$("#news-hide").on("click", function() {$("#news-below-video").hide(); cookie_set('news-hide', "1", 86400 * 3); return false;})
}
